import template from "./users.html";
import controller from "./users.controller";
import "./users.scss";

const BoothsComponent = {
    template,
    controller,
    controllerAs: "controller"
};

export default BoothsComponent;


// WEBPACK FOOTER //
// ./sources/components/users/users-component.js